module.exports = __webpack_public_path__ + "img/yellow connect 4 piece.68cf6ca0.png";